import React from 'react';
import Reflux from 'reflux';
import HeaderStore from '../../../stores/header';
import headerActions from '../../../actions/header';
import translate from '../../../utils/translate';

export default  class SlidingPanel extends Reflux.Component {

  constructor (props) {
    super(props);
    this.state = {
      ofMin: 0
    };

    this.mapStoreToStateKey(HeaderStore, 'headerStoreImported');
    this._handleDocumentClick = this._handleDocumentClick.bind(this);
  }

  mapStoreToStateKey = (store, key) => {
    this.mapStoreToState(store, changes => {
      this.setState(currentState => ({ [key]: {...currentState[key], ...changes} }));
    });
  };

  componentDidMount () {
    document.addEventListener('click', this._handleDocumentClick, false);
  }

  componentWillUnmount () {
    document.removeEventListener('click', this._handleDocumentClick, false);
  }

  componentDidUpdate () {
    if (this.state.headerStoreImported.isActiveSlidingPanel) {
      // that's the hack. there are two pannels at the same time on the page
      // one for mobile, one for desktop
      // we need to focus the close button which is visible
      document.querySelectorAll('.slidingPanel-closeBtn').forEach(btn => btn.checkVisibility() && btn.focus());
    }
  }

  _handleDocumentClick (e) {
    if (e.target.id === 'overlay' && this.props.isDesktop) {
      headerActions.toggleSlidingPanel();
    }
  }

  _handleKeyDown (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      headerActions.toggleSlidingPanel();
    }
  }

  _handleTabOut (e) {
    headerActions.toggleSlidingPanel();
  }

  render () {
    const isOpen = this.state.headerStoreImported.isActiveSlidingPanel;
    const locationText = translate('headerModule', 'LOCATION');
    const menuStatus = isOpen ? 'isopen' : '';
    const offsetObj = menuStatus !== 'isopen' ? {display: 'none'} : {display: 'block', left: 0};
    return (
      <div style={offsetObj}
        className={menuStatus}
        id="slidingPanel-menu"
        role="dialog"
        aria-labelledby="slidingPanel-heading"
        aria-hidden={!isOpen}
      >
        <div tabIndex="0" onFocus={this._handleTabOut} aria-label="Close" />
        <div className="slidingPanel-content">
          <span
            role="button"
            tabIndex="0"
            className="slidingPanel-closeBtn"
            onClick={headerActions.toggleSlidingPanel}
            onKeyDown={this._handleKeyDown}
            aria-label={translate('headerModule', 'CLOSE')}
          />
          <span className="slidingPanel-heading" id="slidingPanel-heading">{locationText}</span>
        </div>
        <div className="slidingPanel-children">
          {isOpen && this.props.children}
        </div>
        <div tabIndex="0" onFocus={this._handleTabOut} aria-label="Close" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/slidingPanel/index.js